<template>
    <div class="container-fluid">
        <v-title :lineage="[{'Settings':'settings'}]">
            Coupons
            <div slot="actions">
                <router-link
                    v-if="$auth.$pages['coupons-redemptions'].isAllowed"
                    :to="{name: 'coupons-redemptions'}"
                    class="btn inline-m">View Redemption List</router-link>
                <router-link
                    v-if="$auth.$pages['add-coupon'].isAllowed"
                    :to="{name: 'add-coupon'}"
                    class="btn btn-link">Add Coupon<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>
            </div>
        </v-title>
        <div class="grid">
            <div class="grid-item">
                <grid
                    :columns="gridColumns"
                    :tabs="gridTabs"
                    :provider="provider"
                    @completed="stopLoadingPage">
                    <v-no-content slot="no-content">
                        <span slot="title">It seems that you have no coupons</span>
                        <span slot="description">You can provide incentives to your customers by using coupons.</span>
                        <div slot="actions">
                            <router-link
                                v-if="$auth.$pages['add-coupon'].isAllowed"
                                :to="{name: 'add-coupon'}"
                                class="btn btn-link">Add Coupon<v-icon class="margin-left-xs" icon="arrow-right"/></router-link>
                        </div>
                    </v-no-content>
                </grid>
            </div>
        </div>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import {vIcon} from '@/components/form';
    import vNoContent from '@/components/v-no-content';
    import Grid from '@/components/grid/grid';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import TabsConfiguration from '@/components/grid/tabs/tabs-configuration';
    import couponColumns from './coupon-columns';

    export default {
        name: 'coupons',
        components: {
            vTitle, vIcon, Grid, vNoContent,
        },
        mixins: [LoadStateMixin],
        data() {
            return {
                gridColumns: couponColumns,
                gridTabs: new TabsConfiguration({
                    id: 'coupon-list',
                    store: this.$store,
                    systemTabs: [
                        {
                            label: 'Issued',
                            filter: [['status', ['issued']]],
                            sortBy: {createdTime: 'desc'},
                        },
                        {
                            label: 'Expired',
                            filter: [['status', ['expired']]],
                            sortBy: {createdTime: 'desc'},
                        },
                        {
                            label: 'Draft',
                            filter: [['status', ['draft']]],
                            sortBy: {createdTime: 'desc'},
                        },
                    ],
                    version: 1,
                }),
            };
        },
        methods: {
            provider(params) {
                return this.$api(({coupons}) => coupons.getAll(params));
            },
        },
    };
</script>
